import { Snippet } from '../snippet/gb-snippet';
riot.tag2('gb-snippet', '<div class="gb-snippet"> {responseText} </div>', '', '', function(opts) {
    this._mixin(Snippet);
});



/** WEBPACK FOOTER **
 ** ./src/tags/snippet/gb-snippet.tag.html
 **/